import React from 'react';
import { observer } from 'mobx-react';

import { CSSObject } from '@emotion/react';
import Box from '@mui/material/Box';

import Icon from '@components/Icon';

import { deleteToken } from '@helpers/token';
import stores from '@stores';
import * as S from './styles';

interface Props {
  customStyles?: CSSObject;
}

const UserProfile = ({ customStyles }: Props) => {
  const {
    sessionStore: { currentUser, isAdmin }
  } = stores;

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const onClickSignOut = (): void => {
    deleteToken();
  };

  return (
    <>
      <Box sx={customStyles}>
        <S.User onClick={handleClick}>
          <S.UserInfo>
            <div className='name'>
              {!!currentUser && `${currentUser?.username}`}
            </div>
          </S.UserInfo>
          <S.UserPhoto>
            <Icon icon='user' size={20} />
          </S.UserPhoto>

        </S.User>

        <S.DropDownMenu
          anchorEl={anchorEl}
          open={open}
          disableAutoFocusItem={true}
          onClose={handleClose}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
          transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        >

          {isAdmin && <S.DdLink to='/admin'>
            Admin Panel
          </S.DdLink>}

          <S.SignOut onClick={onClickSignOut}>
              Sign Out
          </S.SignOut>
        </S.DropDownMenu>
      </Box>
    </>
  );
};

export default observer(UserProfile);
